export default "__VITE_ASSET__D14Pp8dL__"